import React from 'react';
import Grid from '@mui/material/Grid';
import { GridSection, GridLeft, GridRight } from '../../../Episode.Styled';
import {
  CalOMSAdmitHeading,
  CheckboxGridItems,
  CheckboxGridItemsWithField,
  ClientDetails,
  InputFieldGridItems,
} from '../AuthTabCommonUtils';
import {
  clientAdmissionLeftDetails as left,
  clientAdmissionRightDetails as right,
  disabilities,
  ethnicities,
  genders,
  getSocialSecurityNumberOptions,
  getYesNo,
  notAplicable,
  races,
} from '../authTabConstants';
import {
  cid2,
  cid3,
  cid4,
  cid5,
  cid6,
  cid7,
  cid8,
  cid9,
  cid10,
  cid11A,
  cid11B,
  cid12,
  cid13,
  cid14,
  cid15,
  cid16,
  cid17,
  cid18,
  cid19,
} from './CalOMSQuestionnaireConstants';
import { useSelector } from 'react-redux';
import moment from 'moment';

const PageOneCalOMS = () => {
  const getCalOMSAdmitPdfForm = useSelector(
    (state) => state?.calOMSAdmitPdfForm?.data
  );

  const {
    cboName = '',
    prtKey,
    prtID,
    epdIcnCDC = '',
    sapAthID = '',
    sapAthAdmDate,
    prtFname = '',
    prtLname = '',
    caZip = '',
    caBirthFName = '',
    caBirthLName = '',
    caDLID = '',
    caDLIDState = '',
    caMomFName = '',
    sapAth_CboID = '',
    prtDOB = '',
    prt_EthID = '',
    caVet = '',
    caSSN = '',
  } = getCalOMSAdmitPdfForm || {};

  races.forEach((race, index) => {
    race.checked = getCalOMSAdmitPdfForm?.caRace === index ? true : false;
  });

  ethnicities?.forEach((ethnicity, index) => {
    ethnicity.checked = prt_EthID === index ? true : false;
  });

  const caVeteran = getYesNo?.map((getYesNo, index) => ({
    ...getYesNo,
    checked:
      caVet === ''
        ? caVet === index
          ? true
          : false
        : caVet === index
        ? false
        : true,
  }));
  
  const prt_GndID = getCalOMSAdmitPdfForm?.prt_GndID;
  const updatedGenders = genders?.map((gender) => ({
    ...gender,
    checked: gender.label === 'Male' ? prt_GndID === 'M' : prt_GndID === 'F',
  }));

  const clientAdmissionLeftDetails = [
    { ...left[0], value: cboName },
    {
      ...left[1],
      value: `${prtKey || ''}${prtKey && prtID ? ' (' + prtID + ')' : ''}`,
    },
    { ...left[2], value: epdIcnCDC },
  ];

  const admissionRightDetails = [
    { ...right[0], value: sapAth_CboID },
    { ...right[1], value: sapAthID },
    {
      ...right[2],
      value: sapAthAdmDate ? moment(sapAthAdmDate).format('MM/DD/YYYY') : '',
    },
  ];

  return (
    <Grid container>
      <GridSection mt={1} mx={2} container spacing={1}>
        <CalOMSAdmitHeading title="CalOMS Admission Questionnaire" />
      </GridSection>

      <GridSection mt={1} mx={2} container spacing={1}>
        <Grid item container md={10} sm={9} xs={9}>
          <ClientDetails data={clientAdmissionLeftDetails} />
        </Grid>

        <Grid item container md={2} sm={3} xs={3}>
          <ClientDetails data={admissionRightDetails} />
        </Grid>
      </GridSection>

      <GridSection container mt={1} mx={2} spacing={1}>
        <CalOMSAdmitHeading title="Client Identification and Demographics" />
      </GridSection>

      <GridSection mx={2} container spacing={1}>
        <GridLeft item container xs={6}>
          <InputFieldGridItems heading="CID-2" value={prtID} text={cid2} />
          <CheckboxGridItems
            heading="CID-3"
            data={updatedGenders}
            text={cid3}
          />

          <InputFieldGridItems
            heading="CID-4"
            value={moment(prtDOB).format('MM/DD/YYYY')}
            text={cid4}
          />
          <InputFieldGridItems heading="CID-5" value={prtFname} text={cid5} />
          <InputFieldGridItems heading="CID-6" value={prtLname} text={cid6} />
          <CheckboxGridItemsWithField
            heading="CID-7"
            data={getSocialSecurityNumberOptions}
            text={cid7}
            value={caSSN}
          />
          <InputFieldGridItems heading="CID-8" value={caZip} text={cid8} />
          <InputFieldGridItems
            heading="CID-9"
            value={caBirthFName}
            text={cid9}
          />
          <InputFieldGridItems
            heading="CID-10"
            value={caBirthLName}
            text={cid10}
          />
          <InputFieldGridItems heading="CID-11A" value="" text={cid11A} />
          <InputFieldGridItems heading="CID-11B" value="" text={cid11B} />
          <CheckboxGridItemsWithField
            heading="CID-12"
            data={notAplicable}
            text={cid12}
            value={caDLID}
          />
        </GridLeft>

        <GridRight item container xs={6}>
          <CheckboxGridItemsWithField
            heading="CID-13"
            data={notAplicable}
            text={cid13}
            value={caDLIDState}
          />

          <InputFieldGridItems
            heading="CID-14"
            value={caMomFName}
            text={cid14}
          />

          <CheckboxGridItems heading="CID-15" data={races} text={cid15} />

          <CheckboxGridItems heading="CID-16" data={ethnicities} text={cid16} />

          <CheckboxGridItems heading="CID-17" data={caVeteran} text={cid17} />

          <CheckboxGridItems
            heading="CID-18"
            data={disabilities}
            text={cid18}
          />

          <CheckboxGridItems heading="CID-19" data={getYesNo} text={cid19} />
        </GridRight>
      </GridSection>
    </Grid>
  );
};

export default PageOneCalOMS;
